import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { sanitize } from '../../utils/sanitize.js';
import { Pictogram } from '../Pictogram/Pictogram.js';
import { Icon } from '../Icon/Icon.js';

var ChoiceCard = props => {
  var {
    displaySelectField,
    minimizedVersion,
    fullVersion,
    smallerOnMobile
  } = props;
  var inputAttributes = {
    className: 'sr-only',
    id: props.id,
    name: props.name,
    type: props.type,
    value: props.value
  };

  // Add the onChange handler
  if (typeof props.onChange === 'function') {
    inputAttributes.onChange = e => {
      var name = props.value;
      var value = e.target.checked;

      // @ts-ignore
      props.onChange(name, value, e);
    };
    inputAttributes.checked = props.checked;
  } else {
    inputAttributes.defaultChecked = props.checked;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line max-len
    React.createElement("div", {
      className: "choicecard".concat(displaySelectField ? ' new-variant' : '').concat(smallerOnMobile ? ' mini-version' : '').concat(minimizedVersion ? ' no-pictogram-version' : '').concat(fullVersion ? ' full-version' : '')
    }, /*#__PURE__*/React.createElement("input", inputAttributes), /*#__PURE__*/React.createElement("label", _extends({
      htmlFor: props.id
    }, (!props.title || !props.description) && {
      className: 'label-aligned'
    }), props.pictogram && /*#__PURE__*/React.createElement(Pictogram, {
      name: props.pictogram,
      alt: "",
      theme: props.pictogramTheme
    }), props.imageSrc && /*#__PURE__*/React.createElement("img", {
      src: props.imageSrc,
      alt: "",
      className: "choicecard__img"
    }), props.title && /*#__PURE__*/React.createElement("div", {
      className: "label-heading"
    }, props.title), props.description && !props.children && /*#__PURE__*/React.createElement("p", null, props.description), props.children &&
    /*#__PURE__*/
    // eslint-disable-next-line react/no-danger
    React.createElement("div", {
      dangerouslySetInnerHTML: sanitize(props.children)
    }), !(displaySelectField || minimizedVersion) && /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      className: "choicecard__cta"
    }, /*#__PURE__*/React.createElement("span", {
      className: "choicecard__cta-title"
    }, props.selectText || 'Choose'), /*#__PURE__*/React.createElement(Icon, {
      symbol: "Tick24",
      className: "choicecard__cta-icon",
      type: "svginline",
      svgArgs: {
        fill1: '#ffffff'
      }
    }))))
  );
};
ChoiceCard.defaultProps = {
  checked: false,
  minimizedVersion: false,
  type: 'radio' // eslint-disable-line
};

ChoiceCard.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.string,
  displaySelectField: PropTypes.bool,
  id: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  minimizedVersion: PropTypes.bool,
  fullVersion: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  pictogram: PropTypes.string,
  pictogramTheme: PropTypes.oneOf(['beacon']),
  selectText: PropTypes.string,
  smallerOnMobile: PropTypes.bool,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  value: PropTypes.string.isRequired
};

export { ChoiceCard };
